var _ellipse, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodToKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3393,
    cy: 25.5,
    rx: 7.33929,
    ry: 7.5,
    fill: "#6C5CE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3393 22.5C23.4036 22.5 22.3027 25.5 22.3027 25.5C22.3027 25.5 23.4036 28.5 26.3393 28.5C29.2751 28.5 30.3759 25.5 30.3759 25.5C30.3759 25.5 29.2751 22.5 26.3393 22.5ZM26.3393 23.625C27.3525 23.625 28.1742 24.4646 28.1742 25.5C28.1742 26.5354 27.3525 27.375 26.3393 27.375C25.3262 27.375 24.5045 26.5354 24.5045 25.5C24.5045 24.4646 25.3262 23.625 26.3393 23.625ZM26.3393 24.375C26.0474 24.375 25.7674 24.4935 25.5609 24.7045C25.3544 24.9155 25.2384 25.2016 25.2384 25.5C25.2384 25.7984 25.3544 26.0845 25.5609 26.2955C25.7674 26.5065 26.0474 26.625 26.3393 26.625C26.6313 26.625 26.9113 26.5065 27.1178 26.2955C27.3242 26.0845 27.4402 25.7984 27.4402 25.5C27.4402 25.2016 27.3242 24.9155 27.1178 24.7045C26.9113 24.4935 26.6313 24.375 26.3393 24.375Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#4F00E0",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodToKnow);
export default __webpack_public_path__ + "static/media/goodToKnow.dcd9b2c2705a4ee80cfac1ddd68cf26f.svg";
export { ForwardRef as ReactComponent };